<template>
  <!-- Long codes (FALL_50_sencenbaugh) wrap after _ or - first, then anywhere -->
  <span class="coupon-pill" :title="code"><i class="fa-solid fa-ticket" aria-hidden="true"></i><span class="coupon-pill__code"><template v-for="(part, index) in parts">{{ part }}<wbr v-if="index < parts.length - 1" :key="index"></template></span></span>
</template>
<script>
// A discount / scholarship code, the same on subscription cards, charge rows
// and subscription events (charges.scss).
export default {
  name: 'coupon-pill',
  props: {
    code: { type: String, required: true },
  },
  computed: {
    parts() {
      return this.code.split(/(?<=[_-])/);
    },
  },
};
</script>
